<template>
  <div id="global-uploader">
    <!-- 上传 -->
    <uploader
      ref="uploader"
      :options="options"
      :autoStart="false"
      @file-added="onFileAdded"
      @file-success="onFileSuccess"
      @file-progress="onFileProgress"
      @file-error="onFileError"
      class="uploader-app"
    >
      <uploader-unsupport></uploader-unsupport>
      <uploader-btn id="global-uploader-btn" :attrs="attrs" ref="uploadBtn">选择文件</uploader-btn>
      <uploader-list v-show="panelShow">
        <div class="file-panel" slot-scope="props" :class="{'collapse': collapse}">
          <div class="file-title">
            <h2 style="text-align: center;padding: 10px 0;">
              文件上传列表
              <Icon type="ios-close" size="30" @click="panelShow=false" style="  float: right;"/>
            </h2>
          </div>
          <ul class="file-list">
            <li v-for="file in props.fileList" :key="file.id">
              <uploader-file :class="'file_' + file.id" ref="files" :file="file" :list="true"></uploader-file>
            </li>
            <div class="no-file" v-if="!props.fileList.length">
              <i class="nucfont inuc-empty-file"></i> 暂无待上传文件
            </div>
          </ul>
        </div>
      </uploader-list>
    </uploader>
  </div>
</template>
<script>
// import { Message } from "iview";
import { _filesTasks, _filesTasksEnd } from "../api/api.js";
export default {
  data() {
    return {
      options: {
        target: res => {
          res.index += 1;
          return `/api/files/tasks/${res.key}/chunks/${res.index}`;
        }, // 目标上传 URL
        forceChunkSize: true,
        fileParameterName: "file", //上传文件时文件的参数名，默认file
        maxChunkRetries: 1, //最大自动失败重试上传次数
        testChunks: false, //是否开启服务器分片校验
        testMethod: "POST",
        allowDuplicateUploads: true,
        headers: {
          // 在header中添加的验证，请根据实际业务来
          "IVY-VERSION": "V2018.09.25"
        }
      },
      attrs: {
        // accept: [".pdf",".excel"]
      },
      panelShow: false, //选择文件后，展示上传panel
      collapse: true
    };
  },
  methods: {
    fileListShow() {},
    close() {},
    onFileAdded(res) {
      this.panelShow = true;
      _filesTasks({ size: res.size, name: res.name }).then(res_ => {
        const { key, chunkCount, chunkSize } = res_.data;
        res.key = key;
        console.log(res.uploader.opts);

        res.uploader.opts.chunkSize = chunkSize; //动态设置大小
        res.uploader.opts.headers["IVY-TOKEN"] = sessionStorage.getItem("token")
          ? sessionStorage.getItem("token")
          : null;
        res.bootstrap(); //初始化
        res.index = -1;
        res.resume(); //调用下载
      });
    },
    onFileProgress(rootFile, file, chunk) {
      console.log(
        `上传中 ${file.name}，chunk：${chunk.startByte /
          1024 /
          1024} ~ ${chunk.endByte / 1024 / 1024}`
      );
    },
    // 上传成功
    onFileSuccess(rootFile, file, response, chunk) {
      // 内部自动调用
      let res = JSON.parse(response);
      if (res.code == 0) {
        console.log(file);

        _filesTasksEnd(file.key).then(res => {
          if (res.code === 0) {
            const { data } = res;
            this.callBackFn({
              name: file.name,
              uri: data.uri,
              size: file.size
            });
            this.panelShow = false;
            // Message.success("上传成功");
          }
        });
        // file.cancel();
      } else {
        // Message.error(res.message);
      }
    },
    onFileError(rootFile, file, response, chunk) {
      // Message.error(response);
    }
  },
  created() {
    this.$root.$on("openUploader", callBackFn => {
      if (this.$refs.uploadBtn) {
        this.callBackFn = callBackFn;
        this.$refs.uploadBtn.$el.click();
      }
    });
  }
};
</script>
<style>
li {
  list-style-type: none;
}
#global-uploader {
  height: 0;
  overflow: hidden;
}
#global-uploader .uploader-list {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 500px;
  height: 300px;
  z-index: 999;
}
.uploader-list {
  background-color: #fff;
  width: 500px;
  height: 500px;
  border-radius: 10px;
}
.file-list {
  padding: 0 20px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/GlobalUploader.vue